import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Autoplay } from 'swiper'

import { BannerInfoProps } from './types'
import * as Styles from './styles'

SwiperCore.use([Autoplay])

export const BannerMobile = ({ theme, items }: BannerInfoProps) => {
  return (
    <Styles.SwiperContainer>
      <Swiper
        loop={true}
        speed={1000}
        spaceBetween={4}
        grabCursor={true}
        slidesPerView="auto"
        centeredSlides={true}
        autoplay={{ delay: 2500 }}
      >
        {items.map((item, index) => (
          <SwiperSlide key={index}>
            <Styles.Container theme={theme}>
              <Styles.Item>
                <Styles.Icon />
                <Styles.Title dangerouslySetInnerHTML={{ __html: item }} />
              </Styles.Item>
            </Styles.Container>
          </SwiperSlide>
        ))}
      </Swiper>
    </Styles.SwiperContainer>
  )
}
